import {
  $HttpClientOptions,
  AllocationV2SResource,
  CentersResource,
  CountriesResource,
  CurrenciesResource,
  DocumentsResource,
  EmailVerificationsResource,
  ExportsResource,
  Hs10Resource,
  ImportsResource,
  InvitationsResource,
  ItemsResource,
  LanguagesResource,
  MembershipsResource,
  OrdersResource,
  OrganizationsResource,
  OrganizationTokensResource,
  PasswordResetFormsResource,
  ProvincesResource,
  PublicKeysResource,
  RatecardsResource,
  RatesResource,
  RefundsResource,
  RegionsResource,
  ScheduledExportsResource,
  ShippingConfigurationCopiesResource,
  ShippingConfigurationsResource,
  ShippingLabelsResource,
  ShippingNotificationsResource,
  SuggestionsResource,
  SurchargeSettingsResource,
  TiersResource,
  TokensResource,
  UploadsResource,
  UsersResource,
  WebhookDeliveriesResource,
  WebhooksResource,
  ConsumerInvoicesResource,
  B2BInvoicesResource,
  CreditMemosResource,
  B2BCreditMemosResource,
  FeeInvoicesResource,
  B2BDebitNotesResource,
  B2BCreditNotesResource,
} from '@flowio/api-sdk';

export class ApiClientV2 {
  allocation: AllocationV2SResource;

  centers: CentersResource;

  countries: CountriesResource;

  currencies: CurrenciesResource;

  documents: DocumentsResource;

  emailVerifications: EmailVerificationsResource;

  exports: ExportsResource;

  hs10: Hs10Resource;

  imports: ImportsResource;

  invitations: InvitationsResource;

  items: ItemsResource;

  languages: LanguagesResource;

  memberships: MembershipsResource;

  orders: OrdersResource;

  organizations: OrganizationsResource;

  organizationTokens: OrganizationTokensResource;

  passwordResetForms: PasswordResetFormsResource;

  provinces: ProvincesResource;

  publicKeys: PublicKeysResource;

  ratecards: RatecardsResource;

  rates: RatesResource;

  refunds: RefundsResource;

  regionsResource: RegionsResource;

  scheduledExports: ScheduledExportsResource;

  shippingConfigurations: ShippingConfigurationsResource;

  shippingConfigurationsCopies: ShippingConfigurationCopiesResource;

  shippingLabels: ShippingLabelsResource;

  shippingNotifications: ShippingNotificationsResource;

  suggestions: SuggestionsResource;

  surchargeSettings: SurchargeSettingsResource;

  tiers: TiersResource;

  tokens: TokensResource;

  uploads: UploadsResource;

  users: UsersResource;

  webhookDeliveries: WebhookDeliveriesResource;

  webhooks: WebhooksResource;

  consumerInvoices: ConsumerInvoicesResource;

  b2bInvoices: B2BInvoicesResource;

  creditMemos: CreditMemosResource;

  b2bCreditMemos: B2BCreditMemosResource;

  feeInvoices: FeeInvoicesResource;

  b2bDebitNotes: B2BDebitNotesResource;

  b2bCreditNotes: B2BCreditNotesResource;

  constructor(options: $HttpClientOptions) {
    this.allocation = new AllocationV2SResource(options);
    this.centers = new CentersResource(options);
    this.countries = new CountriesResource(options);
    this.currencies = new CurrenciesResource(options);
    this.documents = new DocumentsResource(options);
    this.emailVerifications = new EmailVerificationsResource(options);
    this.exports = new ExportsResource(options);
    this.hs10 = new Hs10Resource(options);
    this.imports = new ImportsResource(options);
    this.invitations = new InvitationsResource(options);
    this.items = new ItemsResource(options);
    this.languages = new LanguagesResource(options);
    this.memberships = new MembershipsResource(options);
    this.orders = new OrdersResource(options);
    this.organizations = new OrganizationsResource(options);
    this.organizationTokens = new OrganizationTokensResource(options);
    this.passwordResetForms = new PasswordResetFormsResource(options);
    this.provinces = new ProvincesResource(options);
    this.publicKeys = new PublicKeysResource(options);
    this.ratecards = new RatecardsResource(options);
    this.rates = new RatesResource(options);
    this.refunds = new RefundsResource(options);
    this.regionsResource = new RegionsResource(options);
    this.scheduledExports = new ScheduledExportsResource(options);
    this.shippingConfigurations = new ShippingConfigurationsResource(options);
    this.shippingConfigurationsCopies = new ShippingConfigurationCopiesResource(options);
    this.shippingLabels = new ShippingLabelsResource(options);
    this.shippingNotifications = new ShippingNotificationsResource(options);
    this.suggestions = new SuggestionsResource(options);
    this.surchargeSettings = new SurchargeSettingsResource(options);
    this.tiers = new TiersResource(options);
    this.tokens = new TokensResource(options);
    this.uploads = new UploadsResource(options);
    this.users = new UsersResource(options);
    this.webhookDeliveries = new WebhookDeliveriesResource(options);
    this.webhooks = new WebhooksResource(options);
    this.consumerInvoices = new ConsumerInvoicesResource(options);
    this.b2bInvoices = new B2BInvoicesResource(options);
    this.creditMemos = new CreditMemosResource(options);
    this.b2bCreditMemos = new B2BCreditMemosResource(options);
    this.feeInvoices = new FeeInvoicesResource(options);
    this.b2bDebitNotes = new B2BDebitNotesResource(options);
    this.b2bCreditNotes = new B2BCreditNotesResource(options);
  }
}

export function createClient(options: $HttpClientOptions): ApiClientV2 {
  return new ApiClientV2(options);
}
